<template>
  <v-dialog
    v-if="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    persistent
    max-width="600px"
    fullscreen
  >
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on" icon>
        <v-icon v-on="on">filter_alt</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dense class="elevation-0 amber darken-1 white--text py-auto">
        <v-toolbar-title class="ml-3">Lọc Tìm Kiếm</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <showcase-filter ref="form" @onFilterChanged="onFilterChanged" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ShowcaseFilter from '@/modules/showcase/ShowcaseFilter.vue'

export default {
  components: { ShowcaseFilter },
  props: {},
  data: () => ({
    dialog: false,
  }),
  methods: {
    cancel() {
      this.dialog = false
      this.$refs.form.reset()
    },
    onFilterChanged(data) {
      this.dialog = false
      this.$emit('onFilterChanged', data)
    },
  },
}
</script>
<style scoped>
</style>
